import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { SectionLabel } from '../components/SectionLabel';
import { ThreeServicesCards } from '../components/ThreeServicesCards';
import { Pricing } from '../components/Pricing';
import { YelpAdsFaq, yelpAdsFaq } from '../components/YelpAdsFaq';
import { ClosingCTA } from '../components/ClosingCTA';
import { SEOHead } from '../components/SEOHead';

/* 2026-09-10 (compliance, Kevin): the first FAQ answer and the meta
   description below both used to say "reputation management"/"reputation"
   as an included feature -- the FAQ answer machine-readable too, via the
   FAQPage JSON-LD. Yelp flagged Viridia for review-related copy a second
   time. Swapped both for the real feature this product actually has in
   that slot (the unified inbox, see components/Reputation.tsx and
   packageIncludes in data/site.ts). Do not reinstate "reputation
   management" or similar copy here.

   2026-09-15 (Kevin, three-services restructure, locked): price changed
   $1,197 -> $897/mo everywhere on this page. Page restructured around
   three columns (Viridia System / Yelp Ads Management / Websites) instead
   of one offer plus a bolted-on website section -- the full website tier
   detail now lives on its own page, /websites, so it is not duplicated
   here. */
const faq = [{
  question: 'How much does the Viridia Analytics system cost?',
  answer: 'The Viridia System is $897 per month and includes the CRM, AI receptionist, marketing, a unified inbox, support, and monthly ad reporting.'
}, {
  question: 'Is there a contract?',
  answer: 'No. Everything is month to month. We believe in earning it.'
}, {
  question: 'What costs extra?',
  answer: 'Yelp Ads Management and a website build are both separate services with their own pricing. See the Yelp Ads and Websites pages for the exact numbers.'
}, ...yelpAdsFaq];
export function PricingPage() {
  return <>
      <SEOHead title="Pricing | The Viridia System, Yelp Ads, or a Website | Viridia Analytics Phoenix" description="Three ways to work with Viridia. The Viridia System at $897/month. Yelp Ads Management at 15% of ad spend. Websites from $500. Month to month, no long contracts." canonical="/pricing" faq={faq} data-id="element-3019" data-mp="cdvd0a101446" />

      <PageHeader label="Pricing" title="Three ways to work with us." intro="Pick the door that matches what you need right now. Every price is on this page, no call required to see it." data-id="element-3020" data-mp="1g08opd8cnhs2" />

      <section className="relative isolate overflow-hidden border-b border-[#1a1a1a] bg-[#0c0c0c]" data-id="element-3021" data-mp="1oyax4duexcpd">
        <div className="mx-auto w-full max-w-6xl px-6 py-20 lg:py-24" data-id="element-3022" data-mp="1trm3yez85tha">
          <SectionLabel data-id="element-3023" data-mp="1yovujxycob6p">All three</SectionLabel>
          <div className="mt-8" data-id="element-3024" data-mp="1yrrpddewijqx">
            <ThreeServicesCards data-id="element-3025" data-mp="23pt8tzg8ol2x" />
          </div>
        </div>
      </section>

      <Pricing data-id="element-3026" data-mp="28nv37gj486tp" />
      <YelpAdsFaq data-id="element-3027" data-mp="28nl7rdfax7gm" />
      <ClosingCTA data-id="element-3028" data-mp="28owenm41mvby" />
    </>;
}